// extracted by mini-css-extract-plugin
module.exports = {"body":"_3QkwThUCJjitBv955avYdX","footer":"Dirx9e9tSMskYzPt0VWbU","content":"_2tDFGGM1lkoAEWc3OG9iLM","contentRight":"_18y3RLXpyleLlYiWXB5taB"};